<ng-container *ngIf="!is_review">
  <!-- Activity ID bar -->
  <div class="row mb-3">
    <div class="col col-12 col-lg-5">
      <h4 class="display-4 m-0">
        {{ 'activity_id' | translate }}:
        <a [href]="source_order_details.source_order_url" target="_blank">
          {{ source_order_details.source_order_id }}
        </a>
      </h4>
    </div>

    <div
      *ngIf="price_summary?.is_bulk_order && related_order_url"
      class="col col-12 col-lg-5 ms-auto mt-2 mt-lg-0"
    >
      <h4 class="display-4 m-0 d-flex gap-2 justify-content-start justify-content-lg-end">
        <span class="text-nowrap">{{ 'related_activity_ids' | translate }}:</span>
        <a [href]="related_order_url" target="_blank">{{ 'view_details' | translate }}</a>
      </h4>
    </div>

    <div
      *ngIf="!price_summary?.is_bulk_order && (related_order_info ?? []).length > 0"
      class="col col-12 col-lg-5 ms-auto mt-2 mt-lg-0"
    >
      <h4 class="display-4 m-0 d-flex gap-2 justify-content-start justify-content-lg-end">
        <span class="text-nowrap">{{ 'related_activity_ids' | translate }}:</span>
        <p class="m-0">
          <ng-container *ngFor="let related_info of related_order_info ?? []; let is_last = last">
            <a [href]="related_info.url" target="_blank">{{ related_info.id }}</a>
            <span *ngIf="!is_last">, </span>
          </ng-container>
        </p>
      </h4>
    </div>
  </div>

  <!-- Order placer/recipient card -->
  <div class="card shadow-sm mb-3">
    <div class="card-body">
      <div class="card-title mb-3">
        <h4>
          {{ source_order_details.source_order_type }}:

          <ng-conatiner [ngSwitch]="order_type_id">
            <span *ngSwitchCase="[1, 1001].includes(order_type_id) && order_type_id">
              {{ source_order_details.carrier.name }}
            </span>

            <span *ngSwitchCase="[3, 9].includes(order_type_id) && order_type_id">
              {{ asset_details.existing_asset.device.manufacturer }}
              {{ asset_details.existing_asset.device.model }}
              <span *ngIf="asset_details.existing_asset.device.imei">
                ({{ asset_details.existing_asset.device.imei }})
              </span>
            </span>

            <span *ngSwitchCase="[14].includes(order_type_id) && order_type_id">
              <span *ngIf="asset_details.existing_asset.device; else lineAsset">
                {{ asset_details.existing_asset.device.manufacturer }}
                {{ asset_details.existing_asset.device.model }}
                {{ asset_details.existing_asset.device.size }} -
                {{ asset_details.existing_asset.device.color }}
              </span>
              <ng-template #lineAsset>
                <span
                  *ngIf="
                    asset_details.existing_asset.line.device_catalog_name;
                    else internationalNumber
                  "
                >
                  {{ asset_details.existing_asset.line.device_catalog_name }}
                </span>
                <ng-template #internationalNumber>
                  {{ asset_details.existing_asset.line.international_number }}
                </ng-template>
              </ng-template>
            </span>

            <span *ngSwitchDefault>
              <ng-container
                *ngIf="asset_details.existing_asset && asset_details.existing_asset.line"
              >
                <span>
                  {{ asset_details.existing_asset.line.international_number }}
                </span>
              </ng-container>
            </span>
          </ng-conatiner>
        </h4>
      </div>

      <div class="row g-3">
        <div class="col">
          <div class="d-flex flex-column">
            <span class="fw-normal mb-2">{{ 'order_placer' | translate }}:</span>
            <span class="d-flex">
              {{ source_order_details.order_initiator.first_name }}
              {{ source_order_details.order_initiator.last_name }} ({{
                source_order_details.order_initiator.email
              }})
              <ts-copy [text]="source_order_details.order_initiator.email" />
            </span>
          </div>
        </div>

        <div class="col">
          <div class="d-flex flex-column">
            <span class="fw-normal mb-2">{{ 'order_recipient' | translate }}:</span>
            <span class="d-flex">
              {{ source_order_details.account_holder.first_name }}
              {{ source_order_details.account_holder.last_name }}
              ({{ source_order_details.account_holder.email }})
              <ts-copy [text]="source_order_details.account_holder.email" />
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="card shadow-sm order-confirmation">
    <div class="card-body">
      <!-- What next notification -->
      <div class="row mb-2">
        <div class="col">
          <h5
            class="order-confirmation__sub-title"
            [innerHTML]="
              'your_order_status'
                | translate: '<b>' + source_order_details.source_system_status + '</b>.'
                | domSanitizer
            "
          ></h5>
          <span
            *ngIf="order_status_desc"
            class="fw-light normalize-external-styles"
            [innerHTML]="order_status_desc | domSanitizer"
          ></span>
        </div>
      </div>

      <!-- Progress tracker -->
      <div class="row py-5 m-auto order-confirmation__tracker">
        <ts-order-tracker [order_tracker_config]="order_tracker" />
      </div>

      <!-- Activity asset card -->
      <ts-selected-asset
        [order_type_id]="order_type_id"
        [asset_details]="asset_details"
        [additional_info]="additional_info"
        page_key="confirmation"
      />

      <!-- Order details -->
      <div *ngIf="price_summary">
        <hr class="mx-n3" />

        <ng-template [ngTemplateOutlet]="orderDetailsHeader" />

        <ng-template
          *ngIf="price_summary && price_summary.is_bulk_order"
          [ngTemplateOutlet]="bulkOrderQuantityLabel"
        />

        <div
          *ngIf="price_summary && price_summary.is_bulk_order; else nonBulkOrderSummary"
          class="row"
        >
          <ts-bulk-order-details class="d-block mb-3" [price_summary]="price_summary" />
        </div>
      </div>

      <!-- Address section -->
      <div *ngIf="show_order_details">
        <hr *ngIf="has_price_summary" class="mx-n3" />

        <ng-template [ngTemplateOutlet]="addressDetails" />
      </div>

      <div *ngIf="source_order_details.payment_details?.card_number">
        <hr class="mx-n3" />
        <h4 class="mb-3">{{ 'payment_details' | translate }}</h4>

        <div class="row mb-3">
          <div class="col col-12">
            <h6 class="mb-2">
              {{ 'your_total' | translate }}:
              {{
                price_summary?.is_bulk_order
                  ? source_order_details.payment_details.bulk_cost_to_card
                  : source_order_details.payment_details.cost_to_card
              }}
            </h6>

            <span>
              {{ 'payment_method_disclosure' | translate }}
            </span>
          </div>
        </div>

        <div class="row row-cols-1 row-cols-sm-2 row-cols-lg-3 g-4">
          <div *ngIf="source_order_details.payment_details" class="col">
            <div class="d-flex flex-column">
              <span class="fw-normal mb-2"> {{ 'payment_method' | translate }}: </span>
              <span class="d-flex align-items-center">
                <img
                  *ngIf="source_order_details.payment_details.card_type"
                  class="img-fluid pe-2 payment-card-img"
                  src="{{ getPaymentCardImage(source_order_details.payment_details.card_type) }}"
                  alt="{{ 'payment_card' | translate }}"
                />
                {{ source_order_details.payment_details.card_number }}
              </span>
              <span>{{ source_order_details.payment_details.cardholder_name }}</span>
              <span>{{ source_order_details.payment_details.expires }}</span>
            </div>
          </div>

          <div *ngIf="source_order_details.payment_details.billing_address" class="col">
            <div class="d-flex flex-column">
              <span class="fw-normal mb-2"> {{ 'billing_address' | translate }}: </span>
              <span>{{ source_order_details.payment_details.billing_address.address1 }}</span>
              <span>{{ source_order_details.payment_details.billing_address.address2 }}</span>
              <span>
                {{ source_order_details.payment_details.billing_address.city }},
                {{ source_order_details.payment_details.billing_address.state }}
                {{ source_order_details.payment_details.billing_address.zip }}
              </span>
              <span>{{ source_order_details.payment_details.billing_address.country }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Additional information section -->
      <div *ngIf="source_order_details.additional_information.length">
        <hr class="mx-n3" />
        <h4 class="mb-3">{{ 'additional_info' | translate }}</h4>

        <ng-container
          *ngTemplateOutlet="
            additionalInfo;
            context: { info: sortAdditionalInfo(source_order_details.additional_information) }
          "
        />
      </div>

      <!-- Comments section -->
      <div *ngIf="source_order_details && source_order_details.comments">
        <hr class="mx-n3" />

        <h4 class="mb-3">
          {{ 'comments' | translate }}
        </h4>
        <div class="row">
          <div class="col">
            <div class="d-flex flex-column">
              <span>{{ source_order_details.comments }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<div *ngIf="is_review" class="row g-3 flex-column">
  <!-- Activity asset card -->
  <div *ngIf="asset_details.existing_asset" class="col">
    <ts-selected-asset
      [order_type_id]="order_type_id"
      [asset_details]="asset_details"
      [additional_info]="additional_info"
      [shipping_address]="source_order_details.shipping_address"
      page_key="review"
    />
  </div>

  <!-- Order Details card -->
  <div *ngIf="show_order_details && ![13].includes(order_type_id)" class="col">
    <div class="card shadow-sm">
      <div class="card-body">
        <ng-template [ngTemplateOutlet]="orderDetailsHeader" />

        <ng-template
          *ngIf="price_summary && price_summary.is_bulk_order"
          [ngTemplateOutlet]="bulkOrderQuantityLabel"
        />

        <ts-bulk-order-details
          *ngIf="price_summary && price_summary?.is_bulk_order"
          class="d-block mb-3"
          [price_summary]="price_summary"
        />

        <hr *ngIf="price_summary && price_summary?.is_bulk_order" class="mx-n3" />

        <ng-template [ngTemplateOutlet]="addressDetails" />
      </div>
    </div>
  </div>

  <!-- Additional information card -->
  <div
    *ngIf="source_order_details && source_order_details.additional_information.length"
    class="col"
  >
    <div class="card shadow-sm">
      <div class="card-body">
        <h4 class="pb-2">{{ 'additional_info' | translate }}</h4>

        <ng-container
          *ngTemplateOutlet="
            additionalInfo;
            context: { info: sortAdditionalInfo(source_order_details.additional_information) }
          "
        />
      </div>
    </div>
  </div>
</div>

<!-- Footer -->
<ng-content select="[navigate-dashboard]" />

<ng-template #orderDetailsHeader>
  <div class="row d-flex justify-content-between card-title">
    <h4 class="col-6">{{ 'order_details' | translate }}</h4>

    <div *ngIf="source_order_details.carrier" class="col-6 d-flex flex-column align-items-end">
      <img
        #carrier_img
        class="img-fluid carrier-img"
        src="{{ source_order_details.carrier.image_url }}"
        [alt]="source_order_details.carrier.name"
        [hidden]="carrier_img.hidden"
        (error)="carrier_img.hidden = true"
      />

      <h6 class="pt-2 text-secondary text-end">
        {{ source_order_details.carrier.name }}
      </h6>
    </div>
  </div>
</ng-template>

<ng-template #bulkOrderQuantityLabel>
  <div class="row">
    <div class="col">
      <h5 class="h5 mb-3">
        <span class="fw-light">{{ 'bulk_order_quantity' | translate }}:</span>
        {{ price_summary!.bulk_order_additional_info!.bulk_quantity! }}
      </h5>
    </div>
  </div>
</ng-template>

<ng-template #addressDetails>
  <div
    class="row row-cols-1 row-cols-sm-2 g-4"
    [ngClass]="{ 'row-cols-lg-3': !is_review, 'flex-column': is_review }"
  >
    <div *ngIf="source_order_details.shipping_address" class="col">
      <div class="d-flex flex-column">
        <span class="fw-normal mb-2">{{ shipping_address_label }}:</span>
        <span>{{ source_order_details.shipping_address.company_name }}</span>
        <span>{{ source_order_details.shipping_address.address1 }}</span>
        <span>{{ source_order_details.shipping_address.address2 }}</span>
        <span>
          {{ source_order_details.shipping_address.city }},
          {{ source_order_details.shipping_address.state }}
          {{ source_order_details.shipping_address.zip }}
        </span>
        <span>{{ source_order_details.shipping_address.country }}</span>
      </div>
    </div>

    <div *ngIf="source_order_details.preferred_address" class="col">
      <div class="d-flex flex-column">
        <span class="fw-normal mb-2"> {{ 'preferred_area_location' | translate }}: </span>
        <span>{{ source_order_details.preferred_address.company_name }}</span>
        <span>{{ source_order_details.preferred_address.address1 }}</span>
        <span>{{ source_order_details.preferred_address.address2 }}</span>
        <span>
          {{ source_order_details.preferred_address.city }},
          {{ source_order_details.preferred_address.state }}
          {{ source_order_details.preferred_address.zip }}
        </span>
        <span>{{ source_order_details.preferred_address.country }}</span>
      </div>
    </div>

    <div *ngIf="source_order_details.shipping_method" class="col">
      <div class="d-flex flex-column">
        <span class="fw-normal mb-2"> {{ 'shipping_method' | translate }}: </span>
        <span>{{ source_order_details.shipping_method }}</span>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #nonBulkOrderSummary>
  <!-- One time cost table -->
  <div *ngIf="price_summary && price_summary.one_time_costs" class="table-responsive">
    <table class="table table-sm non-table">
      <thead>
        <th scope="col" class="h5 pb-2">
          {{ 'one_time_costs' | translate }}
          <span>({{ (isEmployeePayable() ? 'employee' : 'company') | translate }})</span>
        </th>
        <th scope="col"></th>
      </thead>
      <tbody class="table-group-divider border-light-subtle">
        <tr *ngFor="let item of price_summary.one_time_costs; last as last">
          <td class="w-100">
            {{ item.name }} - {{ item.description }} (x {{ item.quantity | number: '1.0-0' }}) &#64;
            {{ item.cost_to_currency }}

            <div *ngIf="item?.additional_info?.option">
              ({{ 'option' | translate }}: {{ item?.additional_info?.option }})
            </div>
          </td>
          <td class="text-end text-nowrap" [ngClass]="{ 'border-bottom-0': last }">
            <span
              *ngIf="item.employee_cost_to_currency && (item.type == 'ACCESSORY' || 'DEVICE')"
              class="material-icons-outlined pe-2 card-icon cursor-default"
              placement="top"
              ngbTooltip="{{ 'employee_cost' | translate }}"
            >
              credit_card
            </span>
            {{ item.total_cost_to_currency }}
          </td>
        </tr>
      </tbody>
      <tfoot class="table-group-divider border-light-subtle">
        <td class="h5 pt-3">{{ 'total' | translate }}</td>
        <td class="h5 pt-3 text-end text-nowrap">
          {{ price_summary.total_one_time_cost }}
        </td>
      </tfoot>
    </table>
  </div>

  <!-- Recurring cost table -->
  <div *ngIf="price_summary && price_summary.recurring_costs" class="table-responsive mt-3">
    <table class="table table-sm mb-0 non-table">
      <thead>
        <th scope="col" class="h5 pb-2">
          {{ 'recurring_costs' | translate }}
        </th>
        <th scope="col"></th>
      </thead>
      <tbody class="table-group-divider border-light-subtle">
        <tr *ngFor="let item of price_summary!.recurring_costs; let last = last">
          <td class="w-100">
            {{ item.name }}
            <span *ngIf="item?.included"> ({{ 'included' | translate }}) </span>
            <span *ngIf="item?.additional_info?.unchanged"> ({{ 'unchanged' | translate }}) </span>
          </td>
          <td class="text-end text-nowrap" [ngClass]="{ 'border-bottom-0': last }">
            <span class="pe-1" *ngIf="getFeatureType(item)">
              <span
                class="d-inline-flex"
                [class.themed-badge-success]="item.sub_type === 'ADDED_FEATURE'"
                [class.themed-badge-danger]="item.sub_type === 'REMOVED_FEATURE'"
              >
                ({{ getFeatureType(item) }})
              </span>
            </span>
            <span [class.text-decoration-line-through]="item.sub_type === 'REMOVED_FEATURE'">
              {{ item.total_cost_to_currency }}/mo.
            </span>
          </td>
        </tr>
      </tbody>
      <tfoot class="table-group-divider border-light-subtle">
        <td class="h5 pt-3">{{ 'total' | translate }}</td>
        <td class="h5 pt-3 text-end text-nowrap">{{ price_summary.total_recurring_cost }}/mo.</td>
      </tfoot>
    </table>
  </div>
</ng-template>

<ng-template #additionalInfo let-info="info">
  <div
    class="row row-cols-1"
    [ngClass]="[is_review ? 'flex-column g-3' : 'row-cols-sm-2 row-cols-lg-3 g-4']"
  >
    <ng-container *ngFor="let field of info">
      <ng-container [ngSwitch]="field.type">
        <ng-container *ngSwitchCase="'address'">
          <div *ngIf="field.value" class="col">
            <div class="d-flex flex-column">
              <span class="fw-normal mb-2" [innerHTML]="field.name | domSanitizer"> </span>
              <span>{{ field.value.address1 }}</span>
              <span>{{ field.value.address2 }}</span>
              <span>
                {{ field.value.city }}
                {{ field.value.state }}
                {{ field.value.zip }}
              </span>
              <span>{{ field.value.country }}</span>
            </div>
          </div>
        </ng-container>

        <ng-container *ngSwitchCase="'file'">
          <div class="col">
            <div class="d-flex flex-column">
              <span class="fw-normal mb-2">{{ field.name }}</span>
              <a class="w-fit-content" href="javascript:void(0)" (click)="download(field.value)">
                {{ field.value.file_name }}
              </a>
            </div>
          </div>
        </ng-container>

        <ng-container *ngSwitchCase="'person_select'">
          <div class="col">
            <div class="d-flex flex-column">
              <span class="fw-normal mb-2">{{ field.name }}</span>
              <span>{{ field.value.first_name }} {{ field.value.last_name }}</span>
              <span>({{ field.value.email }})</span>
            </div>
          </div>
        </ng-container>

        <ng-container *ngSwitchDefault>
          <div [ngClass]="field.type === 'textarea' ? 'col w-100' : 'col'">
            <div class="d-flex flex-column">
              <span class="fw-normal mb-2">{{ field.name }}</span>
              <span>{{ field.value }}</span>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </ng-container>
  </div>
</ng-template>
